module.exports = __webpack_public_path__ + "static/team_kirollos-6021c72399630e3aff778aeea2f64c24.png";